import { Label, Textarea } from '@chain-zen/ui'
import { useState } from 'react'

interface InstructionsInputProps {
  instructions: string
  onSubmit: (instructions: string) => void
}

/**
 * Input component for editing warehouse instructions inline
 */
export const InstructionsInput = ({ instructions, onSubmit }: InstructionsInputProps) => {
  const [value, setValue] = useState(instructions)

  const handleBlur = () => {
    if (value !== instructions) {
      onSubmit(value)
    }
  }

  return (
    <div className="space-y-1">
      <Label className="text-xs font-medium">Instructions</Label>
      <Textarea
        value={value}
        placeholder="Enter warehouse instructions"
        onChange={(e) => setValue(e.target.value)}
        onBlur={handleBlur}
        className="min-h-[30px] text-xs py-1.5"
      />
    </div>
  )
}
